module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("Author’s Note")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "normal"
  }, [_vm._v("My thanks to Open Road Media for including "), _c('i', [_vm._v("Deadly Deceits")]), _vm._v(" in its Forbidden Bookshelf ebook series.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My purpose in writing "), _c('i', [_vm._v("Deadly Deceits")]), _vm._v(" a generation ago was to inform the public about how the CIA distorted intelligence reports, including mine, on the Vietnam War to support White House political goals. I had to obtain a court order against the agency to get the book published in its original form. I felt it was vital, however, to alert the public that many intelligence reports from the CIA could not be trusted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It remains as important today as it was in the Vietnam era for the public to hold the CIA accountable when its reporting reflects political purposes instead of accurate intelligence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My hope is that this ebook publication of "), _c('i', [_vm._v("Deadly Deceits")]), _vm._v(" will serve as a reminder that watching the watchers—the CIA and other intelligence agencies—may be the best way to keep them from straying from their legitimate intelligence-gathering mission.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c082b102","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/franmatter02.vue
// module id = 81
// module chunks = 0